import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate, Outlet } from "react-router-dom";
import NavbarGeneral from "./components/Navbar/navbarGeneral";
import NavbarPersonas from "./components/Navbar/navbarPersonas";
import NavbarEmpresas from "./components/Navbar/navbarEmpresas";
import MobileNavDrawer from "./components/Navbar/MobileNavDrawer";
import Personas from "./pages/Personas";
import Empresas from "./pages/Empresas";
import Footer from "./components/Footer";
import SimulaTuCDT from "./pages/SimulaTuCDT";
import SimulaTuFIC from "./pages/SimulaTuFIC";
import SimuladorCDT from "./pages/SimuladorCDT";
import VinculaTusFinanzas from "./pages/VinculaTusFinanzas";
import VamosAIniciar from "./pages/VamosAIniciar";
import CdtFormulario from "./pages/CdtFormulario";
import PersonasAuthPage from "./pages/auth/PersonasAuthPage";
import EmpresasAuthPage from "./pages/auth/EmpresasAuthPage";
import PersonasDashboard from "./pages/PersonasDashboard";
import PersonasAccount from "./pages/PersonasAccount";
import NavbarBlog from "./components/Navbar/navbarBlog";
import Blog from "./pages/Blog";
import BlogDetails from "./pages/BlogDetails";
import BlogArticle from "./pages/BlogArticle";
import TuPension from "./pages/TuPension";
import TusFICs from "./pages/TusFICs";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react"
import SueldoInteligente from "./pages/SueldoInteligente";
import Valor360 from "./pages/Valor360";
import Transparencia from "./pages/Transparencia";
import QuienesSomos from "./pages/QuienesSomos";
import CfoFraccional from "./pages/CfoFraccional";
import CfoFraccionalPlanes from "./pages/CfoFraccionalPlanes";
import DiagnosticoFinanciero from "./pages/DiagnosticoFinanciero";
import GestionDeCaja from "./pages/GestionDeCaja";
import NavbarCez from "./components/Navbar/navbarCez";
import {
  CezHome,
  CezQuienesSomos,
  CezSectores,
  CezFusagasugaPlateada,
  CezElPlan,
  CezOrganizacion,
  CezAfiliacion,
  CezNoticia,
  CezSectorPage,
} from "./pages/cez/CezPages";
import EmpresasGestionAportes from "./pages/EmpresasGestionAportes";
import EmpresasTramitesDigitales from "./pages/EmpresasTramitesDigitales";
import EmpresasSalud from "./pages/EmpresasSalud";
import EmpresasConstruccion from "./pages/EmpresasConstruccion";
import FinancialIntelligenceHealthcare from "./pages/FinancialIntelligenceHealthcare";
import BlogEmpresarial from "./pages/BlogEmpresarial";
import BlogEmpresarialDetails from "./pages/BlogEmpresarialDetails";
import BlogEmpresarialArticle from "./pages/BlogEmpresarialArticle";
import EmpresasContactPopup from "./components/empresas/EmpresasContactPopup";
import PoliticaTratamientoDatos from "./pages/PoliticaTratamientoDatos";
import Institutional from "./pages/Institutional";
import JulianHerreraCard from "./pages/JulianHerreraCard";
import { institutionalPaths } from "./data/institutionalPages";
import { UsuarioProvider } from "./context/UsuarioContext";
import { EmpresasLanguageProvider } from "./context/EmpresasLanguageContext";

const institutionalRoutes = institutionalPaths.filter((path) => path !== "/transparencia");

const ScrollToTop = () => {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

const NotFound = () => <div className="h-screen flex items-center justify-center bg-red-500 text-white text-3xl">404 - Página no encontrada</div>;

const Layout = ({ children }) => {
  const location = useLocation();
  const isDashboard = location.pathname.startsWith("/personas/dashboard");
  const isCez = location.pathname.startsWith("/empresas/consejo-empresarial-sumapaz");
  const tipoDesdeState = location.state?.tipo;
  const tipoFooter = location.pathname.startsWith("/empresas") || tipoDesdeState === "empresas"
    ? "empresas"
    : "personas";
  
  const tipoNavbar = location.pathname.startsWith("/empresas") || tipoDesdeState === "empresas"
    ? "empresas"
    : location.pathname.startsWith("/blog") || tipoDesdeState === "blog"
    ? "blog"
    : "personas";

  const content = isDashboard ? <UsuarioProvider>{children}</UsuarioProvider> : children;

  return (
    <div
      className={
        isDashboard || isCez
          ? "pt-0"
          : "pt-14 sm:pt-20 lg:pt-28"
      }
    >
      {!isDashboard && !isCez && <MobileNavDrawer />}
      {!isDashboard && !isCez && <NavbarGeneral />}
      {!isDashboard && !isCez && tipoNavbar === "personas" && <NavbarPersonas tipo={tipoNavbar} />}
      {!isDashboard && location.pathname.startsWith("/vincula-tus-finanzas") && <NavbarPersonas tipo={tipoNavbar} />}
      {!isDashboard && tipoNavbar === "empresas" && !isCez && <NavbarEmpresas tipo={tipoNavbar} />}
      {!isDashboard && tipoNavbar === "blog" && <NavbarBlog tipo={tipoNavbar} />}
      {!isDashboard && tipoNavbar === "empresas" && !isCez && <EmpresasContactPopup />}
      {content}
      {!isCez && <Footer tipo={tipoFooter} />}
    </div>
  );
};


const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Navigate to="/personas" replace />} />
        <Route path="/personas/*" element={<Layout><Personas /></Layout>} />
        <Route path="/personas/simula-tu-cdt" element={<Layout><SimulaTuCDT /></Layout>} />
        <Route path="/personas/simula-tu-fic" element={<Layout><SimulaTuFIC /></Layout>} />
        <Route path="/personas/simuladorCDT" element={<Layout><SimuladorCDT /></Layout>} />
        <Route path="/personas/cdt/vamos-a-iniciar" element={<Layout><VamosAIniciar /></Layout>} />
        <Route path="/personas/cdt/formulario" element={<Layout><CdtFormulario /></Layout>} />
        <Route path="/personas/miPension" element={<Layout><TuPension /></Layout>} />
        <Route path="/personas/misFICs" element={<Layout><TusFICs /></Layout>} />
        <Route path="/personas/iniciar-sesion" element={<Layout><PersonasAuthPage /></Layout>} />
        <Route path="/iniciar-sesion" element={<Navigate to="/personas/iniciar-sesion" replace />} />
        <Route path="/personas/dashboard" element={<Layout><PersonasDashboard /></Layout>} />
        <Route path="/personas/dashboard/mi-cuenta" element={<Layout><PersonasAccount /></Layout>} />
        <Route path="/vincula-tus-finanzas" element={<Layout><VinculaTusFinanzas /></Layout>} />
        <Route path="/valor360" element={<Layout><Valor360 /></Layout>} />
        <Route path="/sueldo-inteligente" element={<Layout><SueldoInteligente /></Layout>} />
        <Route
          path="/empresas"
          element={
            <EmpresasLanguageProvider>
              <Layout>
                <Outlet />
              </Layout>
            </EmpresasLanguageProvider>
          }
        >
          <Route index element={<Empresas />} />
          <Route path="salud" element={<Outlet />}>
            <Route index element={<EmpresasSalud />} />
            <Route path="financial-intelligence" element={<FinancialIntelligenceHealthcare />} />
          </Route>
          <Route path="construccion" element={<EmpresasConstruccion />} />
          <Route path="gestion-de-caja" element={<GestionDeCaja />} />
          <Route path="consejo-empresarial-sumapaz" element={<NavbarCez />}>
            <Route index element={<CezHome />} />
            <Route path="quienes-somos" element={<CezQuienesSomos />} />
            <Route path="sectores" element={<CezSectores />} />
            <Route path="sectores/:sectorId" element={<CezSectorPage />} />
            <Route path="fusagasuga-plateada" element={<CezFusagasugaPlateada />} />
            <Route path="el-plan" element={<CezElPlan />} />
            <Route path="organizacion" element={<CezOrganizacion />} />
            <Route path="afiliacion" element={<CezAfiliacion />} />
            <Route path="noticias/:slug" element={<CezNoticia />} />
          </Route>
          <Route path="gestion-de-aportes" element={<EmpresasGestionAportes />} />
          <Route path="tramites-digitales" element={<EmpresasTramitesDigitales />} />
          <Route path="direccion-de-innovacion-financiera" element={<Outlet />}>
            <Route index element={<CfoFraccional />} />
            <Route path="planes" element={<CfoFraccionalPlanes />} />
            <Route path="diagnostico" element={<DiagnosticoFinanciero />} />
          </Route>
          <Route path="direccion-financiera-externa/planes" element={<Navigate to="/empresas/direccion-de-innovacion-financiera/planes" replace />} />
          <Route path="direccion-financiera-externa/diagnostico" element={<Navigate to="/empresas/direccion-de-innovacion-financiera/diagnostico" replace />} />
          <Route path="direccion-financiera-externa" element={<Navigate to="/empresas/direccion-de-innovacion-financiera" replace />} />
          <Route path="cfo-fraccional/planes" element={<Navigate to="/empresas/direccion-de-innovacion-financiera/planes" replace />} />
          <Route path="cfo-fraccional" element={<Navigate to="/empresas/direccion-de-innovacion-financiera" replace />} />
          <Route path="blog/:category/:slug" element={<BlogEmpresarialArticle />} />
          <Route path="blog/:id" element={<BlogEmpresarialDetails />} />
          <Route path="blog" element={<BlogEmpresarial />} />
          <Route path="iniciar-sesion" element={<EmpresasAuthPage />} />
        </Route>
        <Route path="/blog/*" element={<Layout><Blog /></Layout>} />
        <Route path="/blog/:id" element={<Layout><BlogDetails /></Layout>} />
        <Route path="/blog/:category/:slug" element={<Layout><BlogArticle /></Layout>} />
        <Route path="/transparencia" element={<Layout><Transparencia /></Layout>} />
        <Route path="/quienes-somos" element={<Layout><QuienesSomos /></Layout>} />
        <Route path="/contacto/julian-herrera" element={<JulianHerreraCard />} />
        <Route path="/julian-herrera" element={<Navigate to="/contacto/julian-herrera" replace />} />
        <Route path="/politica-tratamiento-datos" element={<Layout><PoliticaTratamientoDatos /></Layout>} />
        {institutionalRoutes.map((path) => (
          <Route key={path} path={path} element={<Layout><Institutional /></Layout>} />
        ))}
        <Route path="*" element={<Layout><NotFound /></Layout>} />
      </Routes>
      <Analytics />
      <SpeedInsights/>
    </Router>
  );
};

export default App;
